// ** Initial State
const initialState = {
    result_list: [],
    total: 0,
    social_UUID: null
}

const chatAdminEventList = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_ADMIN_EVENT_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total,
                social_UUID: action.social_UUID || null
            }
        case 'CHAT_ADMIN_EVENT_LIST_CLEAR':
            return {
                ...state,
                result_list: [],
                total: 0,
                social_UUID: null
            }
        default:
            return { ...state }
    }
}

export {
    chatAdminEventList
}
